import { Injectable } from '@angular/core';

@Injectable()
export class DirectMessageService {
  /** Service constructor */
  constructor() {}
}
